// extracted by mini-css-extract-plugin
export default {"baseColumn":"CustomCarousel_baseColumn__mGzU6","carouselContainer":"CustomCarousel_carouselContainer__UJndf","loadingContainer":"CustomCarousel_loadingContainer__NfrrQ"};